import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { FilterTerms } from 'src/app/shared/models/FIlterTerms';
import { QueryTerms } from 'src/app/shared/models/QueryTerms';
//import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';

@Component({
  selector: 'app-other-doctor-card',
  templateUrl: './other-doctor-card.component.html',
  styleUrls: ['./other-doctor-card.component.scss']
})
export class OtherDoctorCardComponent implements OnInit {
  hideBasedlevel = false;
  clickTimeOut;
  route: string;

  @Input() resultData: any;
  @Input() params: any;
  @Input() showLevels: boolean;
  @Input() position: number;

  @Input()
  set showLevel1(showLevel1: boolean) {
    if (this.showLevels) {
      this.showOnlyLevelDoctor(showLevel1);
    }
  }

  constructor(private router: Router
    //private GAService: GoogleAnalyticsService
    ) { }

  ngOnInit() {
    this.route = window.location.origin + this.router.createUrlTree(['/searchdetails', FilterTerms.Practitioner, this.resultData.id, this.params.networkid], {
      queryParams: {
        address: this.params.address, subproductkey: this.params.subproductkey, loginType: this.params.loginType, searchYear: this.params.searchYear
      }
    });
  }

  cardClickRoute(event) {
    if (this.resultData && event.view.getSelection().toString().length === 0) {
      //this.GAService.pushRelatedProviderClick(this.resultData, this.position + 1);
      this.router.navigate(['/searchdetails', FilterTerms.Practitioner, this.resultData.id, this.params.networkid], {
        queryParams: {
          address: this.params[QueryTerms.address], subproductkey: this.params[QueryTerms.subproductkey], loginType: this.params[QueryTerms.loginType], searchYear: this.params[QueryTerms.searchYear]
        }
      });
    }
    event.preventDefault();
  }

  isAccept(): boolean {
    return this.resultData.acceptingNewPatients === true || this.resultData.acceptingNewPatients === 'true';
  }

  showOnlyLevelDoctor(showLevel1) {
    if (showLevel1) {
      if (this.resultData.level === '2') {
        this.hideBasedlevel = true;
      } else {
        this.hideBasedlevel = false;
      }
    } else if (!showLevel1) {
      if (this.resultData.level === '1') {
        this.hideBasedlevel = true;
      } else {
        this.hideBasedlevel = false;
      }
    }

  }

}
